/* Purchase options: subscribe or one-time, with 1/2/3 bottle tiers.
   Tier sets the quantity; in subscribe mode it also picks the selling plan (1 bottle = every month, 2 = every 2 months, 3 = every 3 months).
   Prices shown here are for display; Shopify applies the real discounts (automatic discounts and the selling plan). */
class QuantityBreaks extends HTMLElement {
  connectedCallback() {
    this.section = this.dataset.section;
    this.price = Number(this.dataset.price) / 100;
    // savings are measured from the regular (compare-at) price when the product is on a launch or sale price, so the numbers match the struck price at the top of the page
    this.base = this.dataset.compare ? Number(this.dataset.compare) / 100 : this.price;
    this.tierPct = [0, 0, Number(this.dataset.pct2), Number(this.dataset.pct3)];
    this.subPct = Number(this.dataset.sub);
    this.plans = this.dataset.plans ? this.dataset.plans.split(',') : [];
    this.fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
    this.tiers = [...this.querySelectorAll('.qb__tier input')];
    this.modes = [...this.querySelectorAll('.qb__mode-opt input')];
    this.planInput = this.querySelector('[data-plan-input]');
    this.qtyInput = document.getElementById('Quantity-' + this.section);
    this.note = this.querySelector('[data-note]');
    this.qty = 1;
    this.tiers.forEach((r) => r.addEventListener('change', () => { this.qty = Number(r.value); this.apply(true); }));
    this.modes.forEach((r) => r.addEventListener('change', () => this.apply(false)));
    if (this.qtyInput) this.qtyInput.addEventListener('change', () => {
      const q = Math.min(Math.max(Number(this.qtyInput.value) || 1, 1), 3);
      if (q !== this.qty) { this.qty = q; this.apply(false); }
    });
    this.apply(false);
    this.setupSticky();
  }
  setupSticky() {
    const bar = this.querySelector('[data-sticky]'), main = document.getElementById('ProductSubmitButton-' + this.section);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar); // a theme animation wrapper above us has a transform, which would break position: fixed
    this.sticky = bar; this.stickyBtn = bar.querySelector('[data-sticky-btn]'); this.stickyPrice = bar.querySelector('[data-sticky-price]');
    this.stickyBtn.addEventListener('click', () => main.click());
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = main.getBoundingClientRect();
      const show = r.bottom < 0; // the main button has scrolled off the top of the screen
      bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', String(!show)); this.stickyBtn.tabIndex = show ? 0 : -1;
    };
    this.onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    update(); this.syncSticky();
  }
  syncSticky() {
    if (!this.sticky) return;
    const sub = this.subscribing, u = this.unit(this.qty, sub), pct = Math.round((1 - u / this.base) * 100);
    this.stickyPrice.textContent = this.fmt.format(u * this.qty);
    this.stickyBtn.textContent = sub ? 'Subscribe & save ' + pct + '%' : 'Add to cart';
  }
  disconnectedCallback() { if (this.onScroll) { window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); } if (this.sticky) this.sticky.remove(); }
  get subscribing() { const m = this.modes.find((r) => r.checked); return !!m && m.value === 'sub'; }
  unit(q, sub) {
    let u = this.price * (1 - this.tierPct[q] / 100);
    if (sub) u *= 1 - this.subPct / 100;
    return u;
  }
  apply(fromTier) {
    const sub = this.subscribing;
    this.tiers.forEach((r) => {
      const q = Number(r.value), card = r.nextElementSibling;
      const u = this.unit(q, sub), pct = Math.round((1 - u / this.base) * 100);
      card.querySelector('[data-price-out]').textContent = this.fmt.format(u * q);
      const was = card.querySelector('[data-was]'); was.textContent = pct > 0 ? this.fmt.format(this.base * q) : '';
      card.querySelector('[data-save]').textContent = pct > 0 ? 'Save ' + pct + '%' : '';
      card.querySelector('[data-sub-note]').style.display = sub ? '' : 'none';
      const badge = card.querySelector('[data-badge]');
      badge.hidden = !(q === 2 || q === 3); badge.textContent = q === 3 ? 'Best value' : q === 2 ? 'Most chosen' : '';
      r.checked = q === this.qty;
    });
    if (this.qtyInput && Number(this.qtyInput.value) !== this.qty) {
      this.qtyInput.value = this.qty; this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (this.planInput) { this.planInput.value = sub ? this.plans[this.qty - 1] || '' : ''; this.planInput.disabled = !sub; }
    if (this.note) this.note.textContent = sub
      ? 'Ships every ' + (this.qty === 1 ? 'month' : this.qty + ' months') + '. Skip, change or cancel any time.'
      : 'Mix any products. The saving applies to your whole order.';
    this.syncSticky();
    const btn = document.getElementById('ProductSubmitButton-' + this.section);
    if (btn) {
      const label = btn.querySelector('span');
      const u = this.unit(this.qty, sub), pct = Math.round((1 - u / this.base) * 100);
      if (label && !btn.disabled) label.textContent = (sub ? 'Subscribe & save ' + pct + '%' : 'Add to cart') + ' · ' + this.fmt.format(u * this.qty);
    }
  }
}
if (!customElements.get('quantity-breaks')) customElements.define('quantity-breaks', QuantityBreaks);
